import React, { useState } from 'react';
import './ThesisDetail.css';
import { ArrowLeft } from 'lucide-react';

function ThesisDetailNonM({ thesis, onBack }) {
  const [openSections, setOpenSections] = useState({
    notice: true,
    problematique: true
  });

  if (!thesis) return null;

  const toggleSection = (section) => {
    setOpenSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  // Gestion des mots-clés (transformation de la chaîne en badges)
  const renderKeywords = (keywords) => {
    if (!keywords) return "Non spécifiés";
    const kwArray = typeof keywords === 'string' ? keywords.split(',') : keywords;
    return kwArray.map((k, index) => (
      <span key={index} className="keyword-tag">{k.trim()}</span>
    ));
  };

  return (
    <div className="thesis-detail-page">
      <div className="glass-card thesis-detail-card">
        
        <div className="detail-content-wrapper">
          {/* --- CÔTÉ GAUCHE: Couverture --- */}
          <div className="detail-image-container">
            <img 
              src={thesis.Couverture_R ?`https://api.memofacdz.com${thesis.Couverture_R}`  : "/placeholder-cover.jpg"} 
              alt={thesis.intitule_M} 
              className="thesis-cover-large" 
            />
          </div>

          {/* --- CÔTÉ DROIT: Informations --- */}
          <div className="detail-info-container">
            <h2 className="detail-title">{thesis.intitule_M}</h2>
            <p className="detail-author">Écrivain : {thesis.Ecrivain}</p>

            {/* Accordéon 1: Notice Bibliographique */}
            <div className="accordion-item">
              <button 
                className={`accordion-button ${openSections.notice ? 'active' : ''}`}
                onClick={() => toggleSection('notice')}
              >
                Notice Bibliographique
                <span className={`arrow ${openSections.notice ? 'rotate' : ''}`}>▼</span>
              </button>
              
              <div className={`accordion-grid-wrapper ${openSections.notice ? 'open' : ''}`}>
                <div className="accordion-inner-content">
                  <div className="info-row">
                    <span className="info-label">Intitulé mémoire :</span>
                    <span className="info-value">{thesis.intitule_M}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Intitulé roman :</span>
                    <span className="info-value">{thesis.intitule_R || "Non spécifié"}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Auteur du roman :</span>
                    <span className="info-value">{thesis.Ecrivain}</span>
                  </div>
                  <div className="info-row vertical">
                    <span className="info-label">Problématique :</span>
                    <div className="long-text">
                        {thesis.resume_M || "Aucun résumé disponible."}
                    </div>
                  </div>
                  {thesis.resume_R && (
                    <div className="info-row vertical">
                      <span className="info-label">Résumé de l'œuvre :</span>
                      <div className="long-text">
                          {thesis.resume_R}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Accordéon 2: Structure & Recherche */}
            <div className="accordion-item">
              <button 
                className={`accordion-button ${openSections.problematique ? 'active' : ''}`}
                onClick={() => toggleSection('problematique')}
              >
                Axes de recherche & Mots-clés
                <span className={`arrow ${openSections.problematique ? 'rotate' : ''}`}>▼</span>
              </button>
              
              <div className={`accordion-grid-wrapper ${openSections.problematique ? 'open' : ''}`}>
                <div className="accordion-inner-content">
                  
                  <div className="info-row vertical">
                    <span className="info-label">Axes / Chapitres :</span>
                    <div className="long-text axe-text">
                        {thesis.Axes && thesis.Axes.length > 0 ? (
                          <ul className="axes-list">
                            {thesis.Axes.map((axe, index) => (
                              <li key={index} style={{marginBottom: '8px'}}>{axe}</li>
                            ))}
                          </ul>
                        ) : "Aucun axe spécifié."}
                    </div>
                  </div>

                  
                  <div className="info-row">
                    <span className="info-label">Mots-clés :</span>
                    <div className="keywords-container">
                      {renderKeywords(thesis.mots_cles)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* --- FOOTER --- */}
        <div className="detail-footer">
          <button className="cta-button return-button" onClick={onBack}>
            <ArrowLeft size={16} /> Retour à la liste
          </button>
        </div>
      </div>
    </div>
  );
}

export default ThesisDetailNonM;